import { Button, DataSource, Layout, Panel} from "@mcleod/components";

export abstract class AutogenLayoutDecline extends Layout {
	buttonConfirmDecline: Button;
	panelAvailable: Panel;
	panelNotAvailable: Panel;
	panelSuccess: Panel;
	sourceCarrierAvailableOrders: DataSource;
}
